import React, { useEffect, useState } from 'react';

import { Box } from '../box/box';
import { Icon } from '../icon';
import { useTheme } from '../styles/styles';
import { Typography } from '../typography/typography';

interface CollapsibleSectionProps {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
  triggerOpen?: string | number | null;
}

export const CollapsibleSection = ({
  title,
  children,
  defaultOpen = false,
  triggerOpen,
}: CollapsibleSectionProps) => {
  const [open, setOpen] = useState(defaultOpen);
  const theme = useTheme();

  useEffect(() => {
    if (triggerOpen) {
      setOpen(true);
    }
  }, [triggerOpen]);

  return (
    <Box
      sx={{
        borderRadius: '14px',
        border: `1px solid ${theme.background.lightGrey3}`,
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        gap={'8px'}
        sx={{
          cursor: 'pointer',
          paddingBlock: '12px',
          paddingLeft: '16px',
          borderBottom: open
            ? `1px solid ${theme.background.lightGrey3}`
            : undefined,
        }}
        onClick={() => setOpen((prev) => !prev)}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          width={20}
          height={20}
          color={theme.background.darkGrey}
          sx={{
            border: 'none',
            boxShadow: 'none',
          }}
        >
          {open ? (
            <Icon
              name={'KeyboardArrowDown'}
              iconProps={{ fontSize: 'small' }}
            />
          ) : (
            <Icon name={'ChevronRight'} iconProps={{ fontSize: 'small' }} />
          )}
        </Box>

        <Typography
          sx={{
            color: theme.background.darkGrey3,
            fontSize: '16px',
            fontWeight: 600,
            lineHeight: '24px',
            letterSpacing: '-0.312px',
          }}
        >
          {title}
        </Typography>
      </Box>

      {open && (
        <Box flexGrow={1} width="100%">
          {children}
        </Box>
      )}
    </Box>
  );
};
